import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ContentLoader, { Rect } from 'react-content-loader';

@inject('QuestionStore') @observer
export default class Replies extends Component {
  componentWillMount() {
    const { QuestionStore } = this.props;
    const { params } = this.props.match;
    QuestionStore.setQuestionId(params.questionId)
		QuestionStore.fetchData();
	}

  render() {
    const { QuestionStore } = this.props;
    return (
  		<section id="content-replies" className="content">
        <ul className="list-replies">
          { QuestionStore.isLoading &&
            <div className="loader">
              <div>
                <ContentLoader height={43.2} speed={1} primaryColor={'#cdcdcd'} secondaryColor={'#e3e3e3'}>
                  <Rect x={9.5} y={12} height={7.5} radius={0} width={68} />
                  <Rect x={9.5} y={28} height={6.5} radius={0} width={98} />
                </ContentLoader>
              </div>

              <div>
                <ContentLoader height={43.2} speed={1} primaryColor={'#cdcdcd'} secondaryColor={'#e3e3e3'}>
                  <Rect x={9.5} y={12} height={7.5} radius={0} width={100} />
                  <Rect x={9.5} y={28} height={6.5} radius={0} width={120} />
                </ContentLoader>
              </div>

              <div>
                <ContentLoader height={43.2} speed={1} primaryColor={'#cdcdcd'} secondaryColor={'#e3e3e3'}>
                  <Rect x={9.5} y={12} height={7.5} radius={0} width={85} />
                  <Rect x={9.5} y={28} height={6.5} radius={0} width={150} />
                </ContentLoader>
              </div>
            </div>
          }

          {QuestionStore.repliedQuestions == 0 && !QuestionStore.isLoading &&
            <p className="no-results">Ainda não existem respostas para este segmento.</p>
          }

          {!QuestionStore.isLoading && QuestionStore.answers.map((answer) => {
						return (
              <li key={answer.id} className={QuestionStore.questionId && QuestionStore.questionId === answer.id ? 'active' : ''}>
                <div className="replie">
                  { answer.product != null &&
                    <h2 className="product-name">{ answer.product.name }</h2>
                  }

                  <h3>{answer.question}</h3>

                  <p>{answer.answer}</p>
                </div>
              </li>
            );
					})}
        </ul>
  		</section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Replies.js